module.exports = __webpack_public_path__ + "img/c00_buildingtechbodkinarrows_Normal_ua.a603d6b1.webp";